<template>
  <div class="cascadas confirmation-page">
    <div class="confirmation-card">

      <!-- Encabezado -->
      <div class="confirmation-header">
        <img src="@/assets/images/patrocinadores/logoXhiBlanco.png" alt="XHIDENXI" class="confirmation-logo">
        <span class="confirmation-date">13&nbsp;·&nbsp;DIC&nbsp;·&nbsp;2026</span>
        <h1 class="confirmation-title">¡REGISTRO<br>RECIBIDO!</h1>
        <p class="confirmation-sub">XHIDENXI &mdash; Reto Entre Cascadas</p>
      </div>

      <div class="confirmation-body">

        <!-- Folio -->
        <div class="folio">
          <div class="folio__notch folio__notch--left" aria-hidden="true"></div>
          <div class="folio__notch folio__notch--right" aria-hidden="true"></div>
          <span class="folio__label">Número de folio provisional</span>
          <div class="folio__number">{{ String($route.params.numeroCorredor).padStart(4, '0') }}</div>
          <span class="folio__badge">⚠️ Validación de pago pendiente</span>
        </div>

        <!-- Info -->
        <div class="info-block">
          <h3 class="info-block__title">Confirmación</h3>
          <p>
            Los organizadores revisarán tu comprobante para asignarte tu <strong>número de corredor oficial</strong>.
            Nos pondremos en contacto contigo a la brevedad para confirmar la recepción y asegurar tu lugar en la
            línea de salida.
          </p>
          <div class="info-block__note">
            <strong>Nota:</strong> tu registro quedará pendiente si el pago no coincide con los datos proporcionados
            o fue realizado de forma incorrecta.
          </div>
        </div>

        <!-- WhatsApp -->
        <div class="whatsapp-block">
          <span class="tag tag--dark">Tu foto de corredor</span>
          <p>
            Una vez que confirmemos tu registro oficial, envíanos una foto tuya realizando actividad física
            o corriendo para tu ficha de corredor:
          </p>

          <a href="https://wa.me/525540861907" target="_blank" class="btn btn--dark whatsapp-btn">
            <span aria-hidden="true">📞</span>
            <span>55&nbsp;4086&nbsp;1907</span>
          </a>

          <button type="button" class="back-link" @click="regresar">
            <svg viewBox="0 0 24 24" width="16" height="16"><path d="M19 12H5m0 0l6-6m-6 6l6 6" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>
            Volver al inicio
          </button>
        </div>

      </div>

      <!-- Footer -->
      <div class="confirmation-footer">
        Nos vemos entre las cascadas &middot; XHIDENXI 2026
      </div>

    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()

onMounted(() => {
  window.scrollTo({ top: 0, behavior: 'smooth' })
})

const regresar = () => {
  router.replace('/')
}
</script>

<style setup>
@import url('https://fonts.googleapis.com/css2?family=Anton&family=Inter:wght@300;400;600;700;800&display=swap');

.confirmation-page {
  --forest-950: #0d1912;
  --forest-900: #12241a;
  --forest-800: #1b3527;
  --forest-700: #274c37;
  --moss-500: #7f9c5c;
  --moss-400: #a2bd82;
  --water-600: #2f5f66;
  --gold-500: #c9a04a;
  --paper-050: #faf7ee;
  --paper-100: #f1ead9;
  --ink-900: #14231a;

  --font-display: 'Anton', 'Arial Narrow', sans-serif;
  --font-body: 'Inter', sans-serif;

  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2.5rem 1.25rem;
  font-family: var(--font-body);
  color: var(--ink-900);
  background:
    radial-gradient(120% 90% at 50% 0%, rgba(127,156,92,0.14), transparent 60%),
    linear-gradient(180deg, var(--forest-900) 0%, var(--forest-950) 60%, #060b08 100%);
}

.confirmation-page :is(h1, h3) { font-family: var(--font-display); font-weight: 400; margin: 0; }

.confirmation-card {
  width: 100%;
  max-width: 640px;
  background: var(--paper-050);
  border-radius: 26px;
  overflow: hidden;
  box-shadow: 0 40px 80px rgba(0,0,0,0.35);
}

/* ---------- header ---------- */
.confirmation-header {
  background: var(--forest-950);
  color: #fff;
  text-align: center;
  padding: 3rem 2rem 3.5rem;
}
.confirmation-logo {
  display: block;
  width: auto;
  max-width: 200px;
  height: auto;
  max-height: 76px;
  margin: 0 auto 1.75rem;
  filter: brightness(0) invert(1);
  opacity: 0.95;
}
.confirmation-date {
  display: inline-block;
  border: 2px solid #fff;
  border-radius: 10px;
  padding: 6px 20px;
  font-weight: 800;
  letter-spacing: 2px;
  font-size: 0.8rem;
  margin-bottom: 1.5rem;
}
.confirmation-title { font-size: clamp(2rem, 6vw, 2.6rem); line-height: 1; letter-spacing: 1px; margin-bottom: 0.75rem; }
.confirmation-sub { font-weight: 300; letter-spacing: 2px; text-transform: uppercase; font-size: 0.78rem; color: var(--paper-100); opacity: 0.8; margin: 0; }

/* ---------- body ---------- */
.confirmation-body { padding: 3rem 2rem 1rem; text-align: center; }

.tag { display: inline-block; font-size: 0.72rem; font-weight: 700; letter-spacing: 2.5px; text-transform: uppercase; padding: 8px 18px; border-radius: 999px; margin-bottom: 1rem; }
.tag--dark { background: var(--forest-950); color: var(--paper-100); }

.folio {
  position: relative;
  background: #fff;
  border: 1px dashed rgba(20,35,26,0.25);
  border-radius: 20px;
  padding: 2rem 1.5rem;
  margin-bottom: 2.5rem;
}
.folio__notch { position: absolute; top: 50%; transform: translateY(-50%); width: 26px; height: 26px; border-radius: 50%; background: var(--forest-950); display: none; }
@media (min-width: 560px) {
  .folio__notch { display: block; }
  .folio__notch--left { left: -13px; }
  .folio__notch--right { right: -13px; }
}
.folio__label { display: block; font-size: 0.75rem; font-weight: 700; letter-spacing: 2px; text-transform: uppercase; color: var(--forest-700); margin-bottom: 0.75rem; }
.folio__number { font-family: var(--font-display); font-size: clamp(3rem, 10vw, 4.5rem); line-height: 1; color: var(--forest-950); margin-bottom: 1rem; }
.folio__badge { display: inline-block; background: var(--gold-500); color: #3a2c05; font-weight: 800; font-size: 0.78rem; letter-spacing: 0.5px; padding: 8px 18px; border-radius: 999px; }

.info-block { text-align: left; background: #fff; border: 1px solid rgba(20,35,26,0.07); border-radius: 18px; padding: 1.75rem; margin-bottom: 2.5rem; }
.info-block__title { font-size: 1.05rem; letter-spacing: 0.5px; color: var(--forest-950); margin-bottom: 0.75rem; }
.info-block p { line-height: 1.7; margin: 0 0 1.25rem; color: var(--ink-900); }
.info-block__note {
  background: rgba(201,74,74,0.08);
  border: 1px solid rgba(201,74,74,0.25);
  color: #7a2b2b;
  border-radius: 12px;
  padding: 1rem 1.15rem;
  font-size: 0.9rem;
  line-height: 1.55;
}

.whatsapp-block p { color: var(--forest-700); line-height: 1.6; margin: 0 auto 1.75rem; max-width: 460px; }

.btn { display: inline-flex; align-items: center; justify-content: center; gap: 10px; border: 2px solid transparent; border-radius: 999px; padding: 16px 34px; font-weight: 800; letter-spacing: 1px; font-size: 0.9rem; cursor: pointer; transition: transform .25s ease, background .25s ease; text-decoration: none; }
.btn--dark { background: var(--forest-950); color: var(--paper-050); }
.btn--dark:hover { transform: translateY(-3px); background: var(--forest-800); }

.whatsapp-btn { width: 100%; max-width: 320px; margin: 0 auto; }

.back-link {
  display: inline-flex; align-items: center; gap: 8px;
  margin-top: 1.75rem;
  background: none; border: none; cursor: pointer;
  color: var(--forest-700);
  font-weight: 700; letter-spacing: 0.5px; font-size: 0.85rem;
  text-transform: uppercase;
  padding: 8px 4px;
}
.back-link:hover { color: var(--forest-950); }

/* ---------- footer ---------- */
.confirmation-footer {
  background: var(--moss-500);
  color: var(--forest-950);
  text-align: center;
  padding: 1.1rem;
  font-weight: 800;
  letter-spacing: 2px;
  font-size: 0.78rem;
  text-transform: uppercase;
}

@media (max-width: 480px) {
  .confirmation-header { padding: 2.5rem 1.5rem 3rem; }
  .confirmation-body { padding: 2.5rem 1.25rem 1rem; }
}
</style>
